const FacebookPageCard = ({
  pageUrl = "https://www.facebook.com/englishvocabulary365",
  pageName = "English Vocabulary",
  followers = "2000 followers",
  avatarImage = "/images/commons/vocabulary-footer.webp",
  showLikeButton = false,
  maxWidth = "550px"
}) => {
  const cardStyle = {
    maxWidth: maxWidth,
    width: '100%',
    transition: 'transform 0.2s ease',
  };

  const coverImageStyle = {
    objectFit: 'cover',
  };

  const avatarStyle = {
    width: '40px',
    height: '40px',
    border: '2px solid white',
  };

  const facebookHeaderStyle = {
    backgroundColor: '#3b5998',
  };

  return (
    <a
      href={pageUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none"
    >
      <div
        className="card shadow-sm rounded-3 overflow-hidden mx-auto"
        style={cardStyle}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
      >
        {/* Cover Image */}
        <img
          src="/images/commons/footer.webp"
          alt="Facebook Page Cover"
          className="card-img-top"
          style={coverImageStyle}
        />

        {/* Header with Avatar and Info */}
        <div
          className="text-white p-2 px-3"
          style={facebookHeaderStyle}
        >
          <div className={`d-flex align-items-center ${showLikeButton ? 'justify-content-between' : ''}`}>
            <div className="d-flex align-items-center">
              <img
                src={avatarImage}
                alt="Page Avatar"
                className="rounded-circle"
                style={avatarStyle}
              />
              <div className="ml-2 text-left">
                <div className="font-weight-bold">{pageName}</div>
                <small className="text-left">{followers}</small>
              </div>
            </div>

            {showLikeButton && (
              <button
                className="btn btn-light btn-sm px-3"
                onClick={(e) => e.preventDefault()}
              >
                <img width="18" alt="like" src="/images/commons/icons/like.png" />
              </button>
            )}
          </div>
        </div>
      </div>
    </a>
  );
};

export default FacebookPageCard;
